export default { // consistent across mcom and bcom
  inStoreTodayCurbsideToday: 'Available for in-store or curbside pickup if ordered by __CUTOFF__.',
  inStoreTodayCurbsideTomorrow: 'Available for in-store pickup today if ordered by __CUTOFF__ or curbside tomorrow.',
  inStoreTodayCurbsideFuture: 'Available for in-store pickup today if ordered by __CUTOFF__ or curbside on __OTHERDATE__.',
  inStoreTodayCurbsideUnavailable: 'Available for in-store pickup if ordered by __CUTOFF__.',
  inStoreTomorrowCurbsideToday: 'Available for curbside pickup today if ordered by __CUTOFF__ or in store tomorrow.',
  inStoreTomorrowCurbsideTomorrow: 'Available for in-store or curbside pickup.',
  inStoreTomorrowCurbsideFuture: 'Available for in-store pickup tomorrow or curbside on __OTHERDATE__.',
  inStoreTomorrowCurbsideUnavailable: 'Available for in-store pickup.',
  inStoreFutureCurbsideToday: 'Available for curbside pickup today if ordered by __CUTOFF__ or in store __OTHERDATE__.',
  inStoreFutureCurbsideTomorrow: 'Available for curbside pickup tomorrow or in store __OTHERDATE__.',
  inStoreFutureCurbsideFuture: 'Available for in-store or curbside pickup.',
  inStoreFutureCurbsideUnavailable: 'Available for in-store pickup.',
  inStoreUnavailableCurbsideToday: 'At this time, items must be picked up curbside. Order by __CUTOFF__.',
  inStoreUnavailableCurbsideTomorrow: 'At this time, items must be picked up curbside.',
  inStoreUnavailableCurbsideFuture: 'At this time, items must be picked up curbside.',
  inStoreTodayCurbside: 'Order by __CUTOFF__.',
  topLineMessage: 'Pick up __DAY__ ',
};
